import React from "react";
import "./InputRadioGroup.scss";

type RadioOption = {
  value: string;
  label: string;
};

type RadioGroup = {
  label?: string;
  options: RadioOption[];
};

type InputRadioGroupProps = {
  name: string;
  options: RadioGroup[];
  selectedValue?: string;
  onChange?: (value: string) => void;
  spacing?: string;
  align?: "flex-start" | "center" | "flex-end" | "space-between";
  groupLabel?: string;
  required?: boolean;
  className?: string;
};

const InputRadioGroup: React.FC<InputRadioGroupProps> = ({
  name,
  options,
  selectedValue,
  onChange,
  spacing = "12px",
  align = "flex-start",
  groupLabel,
  required = false,
  className = "",
}) => {
  const handleChange = (value: string) => {
    onChange?.(value);
  };

  return (
    <div className={`input-radiogroup ${className}`}>
      {groupLabel && (
        <div className="input-radiogroup__header">
          <span className="input-radiogroup__grouplabel">{groupLabel}
            {required && <span className="input-dropdown__required">*</span>}
          </span>
        </div>
      )}
      
      {options.map((group, groupIndex) => (
        <div key={groupIndex} className="input-radiogroup__group">
          {group.label && (
            <div className="input-radiogroup__grouplabel">
              {group.label}
            </div>
          )}
          {group.options.map((option) => (
            <div
              key={option.value}
              className={`input-radio ${align}`}
              style={{ justifyContent: align }}
            >
              <input
                type="radio"
                name={name}
                id={`${name}-${option.value}`}
                checked={selectedValue === option.value}
                onChange={() => handleChange(option.value)}
                required={required}
                className={`input-radio__input ${className}`}
              />
              <label
                htmlFor={`${name}-${option.value}`}
                className="input-radio__label"
                style={{ marginLeft: align !== "space-between" ? spacing : "0" }}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default InputRadioGroup;